import { useState } from "react";
import { Check, Crown, Loader2 } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { PLANS } from "@/lib/content";
import { startCheckout, PLAN_LOOKUP } from "@/lib/checkout";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function MembershipShields() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(null);
  const buy = async (plan) => {
    setBusy(plan.id);
    await startCheckout(PLAN_LOOKUP[plan.id], user, navigate);
    setBusy(null);
  };
  return (
    <div className="grid md:grid-cols-2 gap-6">
      {PLANS.map((plan) => {
        const gold = plan.style === "gold";
        return (
          <div
            key={plan.id}
            className={`relative rounded-2xl p-6 sm:p-8 ${gold ? "shield-gold" : "shield-silver"}`}
            data-testid={`plan-${plan.id}`}
          >
            {plan.popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 btn-gold text-[11px] font-black tracking-widest px-4 py-1 rounded-full">
                MOST POPULAR
              </div>
            )}
            <div className="flex items-center gap-4 mb-5">
              <div className={`w-16 h-16 rounded-xl flex items-center justify-center ${gold ? "bg-smasher-gold/15" : "bg-white/5"}`}>
                {gold ? (
                  <img src={ASSETS.hammerBadge} alt="Pro" className="w-11 h-11 object-contain" />
                ) : (
                  <img src={ASSETS.starterBadge} alt="Starter" className="w-11 h-11 object-contain rounded-md" data-testid="starter-badge" />
                )}
              </div>
              <div>
                <div className={`font-heading font-black text-2xl ${gold ? "text-gradient-gold" : "text-gradient-chrome"}`}>{plan.name}</div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading font-black text-4xl text-white">${plan.price}</span>
                  <span className="text-slate-400 text-sm font-bold">/MONTH</span>
                </div>
              </div>
            </div>
            <div className={`text-xs font-black tracking-widest mb-4 ${gold ? "text-smasher-gold" : "text-slate-400"}`}>{plan.tagline}</div>
            <ul className="space-y-2.5 mb-6">
              {plan.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm text-slate-200">
                  <Check className={`w-4 h-4 mt-0.5 shrink-0 ${gold ? "text-smasher-gold" : "text-emerald-400"}`} />
                  {f}
                </li>
              ))}
            </ul>
            <button
              onClick={() => buy(plan)}
              disabled={busy === plan.id}
              className={`w-full py-3 rounded-xl font-heading font-black tracking-wide flex items-center justify-center gap-2 ${gold ? "btn-gold" : "bg-gradient-to-b from-orange-500 to-orange-600 text-white hover:brightness-110 transition"}`}
              data-testid={`join-${plan.id}-button`}
            >
              {busy === plan.id ? <Loader2 className="w-4 h-4 animate-spin" /> : gold && <Crown className="w-4 h-4" />} {plan.cta}
            </button>
          </div>
        );
      })}
    </div>
  );
}
